import type { MessageUsageEvent } from "@lumen/shared";
import { t } from "../../i18n";

function cacheHitPercent(cacheReadTokens: number, promptTokens: number) {
  return promptTokens > 0
    ? Math.round((cacheReadTokens / promptTokens) * 100)
    : 0;
}

export function MessageUsageDetails({
  events,
}: {
  events: MessageUsageEvent[];
}) {
  const totals = events.reduce(
    (sum, event) => ({
      promptTokens: sum.promptTokens + event.promptTokens,
      completionTokens: sum.completionTokens + event.completionTokens,
      totalTokens: sum.totalTokens + event.totalTokens,
      cacheReadTokens: sum.cacheReadTokens + event.cacheReadTokens,
    }),
    {
      promptTokens: 0,
      completionTokens: 0,
      totalTokens: 0,
      cacheReadTokens: 0,
    },
  );
  return (
    <div className="mt-2 border-t border-stone-200 pt-2 dark:border-white/10">
      <div className="font-medium">{t("Token usage")}</div>
      {events.map((event, index) => (
        <div key={event.id} className="mt-1 flex flex-wrap gap-x-2 gap-y-0.5">
          <span className="font-medium">
            {events.length > 1 ? `${t("Request")} ${index + 1}` : t("Request")}
          </span>
          <span className="opacity-75">
            {event.kind} · {new Date(event.createdAt).toLocaleTimeString()}
          </span>
          <span>
            {t("prompt")} {event.promptTokens.toLocaleString()} ({t("cache")}{" "}
            {event.cacheReadTokens.toLocaleString()},{" "}
            {cacheHitPercent(event.cacheReadTokens, event.promptTokens)}%) ·{" "}
            {t("completion")} {event.completionTokens.toLocaleString()} ·{" "}
            {t("total")} {event.totalTokens.toLocaleString()}
          </span>
        </div>
      ))}
      {events.length > 1 && (
        <div className="mt-1 font-medium">
          {t("Total")}: {t("prompt")} {totals.promptTokens.toLocaleString()} (
          {t("cache")} {totals.cacheReadTokens.toLocaleString()},{" "}
          {cacheHitPercent(totals.cacheReadTokens, totals.promptTokens)}%) ·{" "}
          {t("completion")} {totals.completionTokens.toLocaleString()} ·{" "}
          {t("total")} {totals.totalTokens.toLocaleString()}
        </div>
      )}
    </div>
  );
}
